import theme from '@/constants/theme';
import React, { InputHTMLAttributes, useId } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLSelectElement> {
  className?: string;
  label?: string;
  helperText?: string;
}

const Select = React.forwardRef<HTMLSelectElement, InputProps>(
  ({ className, label, helperText, ...props }, ref) => {
    const selectId = useId();

    const SelectComponent = (
      <select
        id={selectId}
        style={{
          height: 48,
          borderWidth: 1,
          borderRadius: 8,
          paddingLeft: 12,
          paddingRight: 12,
          color: theme.colors.text.body,
          backgroundColor: theme.colors.background.secondary,
          border: `1px solid ${theme.colors.border}`,
          maxWidth: '100%',
          ...props.style,
        }}
        ref={ref}
        {...props}
      />
    );

    if (label) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <label htmlFor={selectId} style={{ color: theme.colors.text.body }}>
              {label}
            </label>
            {helperText && <small style={{ color: theme.colors.text.caption }}>{helperText}</small>}
          </div>
          {SelectComponent}
        </div>
      );
    }

    return SelectComponent;
  },
);

Select.displayName = 'Select';

export default Select;
